import { styled } from '@mui/system';
import { Card } from '@mui/material';

export const GroupContainer = styled(Card)(({ theme }) => ({
  minWidth: '450px',
  padding: 16,
}));
